import { cronToParts } from '@/features/chat/phase1/cronParts'

const HOUR = 3_600_000
// Every supported shape fires at a fixed minute, so walking whole hours finds it.
const SHAPES = ['hourly', 'daily', 'weekdays', 'weekly', 'monthly']
// Long enough for a monthly run on the 31st to skip a 30-day month.
const MAX_HOURS = 24 * 62

function matches(parts, at) {
  if (parts.repeat === 'hourly') return true
  if (at.getHours() !== parts.hour) return false
  if (parts.repeat === 'weekdays') return at.getDay() >= 1 && at.getDay() <= 5
  if (parts.repeat === 'weekly') return parts.weekdays.includes(at.getDay())
  if (parts.repeat === 'monthly') return at.getDate() === parts.dayOfMonth
  return true
}

function scan(cron, fromMs, step) {
  const parts = cronToParts(cron)
  if (!SHAPES.includes(parts.repeat)) return null
  const start = new Date(fromMs)
  start.setMinutes(parts.minute, 0, 0)
  for (let i = 0; i < MAX_HOURS; i += 1) {
    const at = new Date(start.getTime() + step * i * HOUR)
    if ((step > 0) !== (at.getTime() > fromMs)) continue
    if (matches(parts, at)) return at
  }
  return null
}

/** The first run strictly after `fromMs`, in local time; null if we can't place it. */
export const nextCronRun = (cron, fromMs = Date.now()) => scan(cron, fromMs, 1)

/** The latest run at or before `fromMs`, in local time; null if we can't place it. */
export const prevCronRun = (cron, fromMs = Date.now()) => scan(cron, fromMs, -1)
